import { errorCodeMessage } from '../services/errorCodes';

/**
 * Normalize a SignalR `ChatHub` "Error" payload to a display string.
 *
 * The hub emits two shapes on the same event: a plain string for simple
 * validation errors ("Message cannot be empty."), and a `{ code, message }`
 * object for the structured ones (`kicked`, `not_host`, …). The legacy
 * live-chat handler assumed a string and passed the value straight to React
 * state — an object there renders as a Text child and throws
 * "Objects are not valid as a React child". Funnel both shapes through this.
 *
 * CORE-467 — prefer canonical Russian copy from the shared error-code registry
 * when the payload carries a known `code`; the hub's own `message` is English
 * (developer-facing) and was previously leaking straight into the UI. Fall
 * back to the server message, then a calm generic.
 */
export function normalizeHubError(err: unknown): string {
  if (typeof err === 'string') return err;
  if (err && typeof err === 'object') {
    const code = (err as { code?: unknown }).code;
    const mapped = typeof code === 'string' ? errorCodeMessage(code) : null;
    if (mapped) return mapped;
    const message = (err as { message?: unknown }).message;
    if (typeof message === 'string' && message.length > 0) return message;
  }
  // Calm, brand-voice fallback for an unknown shape (никаких восклицаний).
  return 'Что-то пошло не так. Попробуйте ещё раз.';
}
